// PAQUETES
import React, {useState, useEffect} from "react";
import SidebarUsuario from '../../partials/sidebarUsuario';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import axios from "axios";
// componentes
import CambiarFoto from "./cambiarFoto";
import CambiarContrasena from "./cambiarContrasena";
import EliminarCuenta from "./eliminarCuenta";
import ZonaCargando from "../zonaCargando";

function Micuentausuario() {
    
    const location = useLocation();
    const navigate = useNavigate();
    const routeParams = useParams();

    let urlVolver = "/cliente/mi-cuenta/" + routeParams.username;
    const [usuario, setUsuario]   = useState(null);
    const [cargando, setCargando] = useState(true);
    
     
    useEffect(() => {
        const verifToken  = axios.get("/verificar-token", {  withCredentials: true  });

        Promise.all([verifToken])
        .then(([resVerif]) => {
            if(!resVerif.data.usuario){ return navigate("/alerta", {state: {titulo:"No estás autenticado", mensaje:"No estás autenticado, por favor inicia sesión.", urlMensaje:"/iniciar-sesion", nombreBoton:"Volver a iniciar sesión"} } ); }
            setUsuario(resVerif.data.usuario); 
        })
        .catch((err) => {  console.error("Error al inicializar:", err);   })
        .finally(() => { setCargando(false); });


        // Modificar la clase de body par página de registro - styles.css /////////
        document.body.classList.add('claseBodyPrivadas');
    return () => { document.body.classList.remove('claseBodyPrivadas') }
    }, [location.state, navigate]);
    
 
    
    


    return(
    <div>
    { cargando ? <ZonaCargando /> :
        !usuario ? null : 
        <div className='d-flex flex-row'>

            {/* BARRA LATERAL */}
            <SidebarUsuario />


            {/* Columna 2 */}
            <div className="flex-grow-1 container-fluid">
                
                {/* Contenedor título  */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-white ">
                    <h1 className="h2 text-white">Mi cuenta</h1>
                    <div className="btn-toolbar mb-2 mb-md-0">
                        <div className="btn-group me-2">
                        {/* Cambiar foto y pasamos datos para usar */}
                        <CambiarFoto urlVolver={urlVolver} usuario={usuario.username} />
                        </div>

                        <div className="btn-group me-2">
                        {/* Cambiar contraseña*/}
                        <CambiarContrasena urlVolver={urlVolver} usuario={usuario.username} />
                        </div>
                    </div>
                </div>
                <div className="container">
                    {/* Foto y nombre */}
                    <div className="p-5 mb-4 contenedorOscuro rounded-3">
                        <div className="row">
                            {/* Imagen */}
                            <div className="col-lg-6">
                                    <div className="d-flex justify-content-center"> <img className="imagenPrincipal" src={usuario.avatar}  alt="" /></div>
                            </div>

                            {/* PUNTOS */}
                            <div className="col-lg-6">
                                <div className="container-fluid py-5">
                                    <h1 className="display-5 fw-bold">¡Hola {usuario.username} !</h1>
                                    <p className="col-md-8 fs-4">Esta es la zona de tu cuenta. Aquí puedes ver toda la información referente a tus datos.</p>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <i className="bi bi-star-fill px-2 py-1 rounded-circle" style={{ backgroundColor:"#0E1465" , color: "#ffff00", marginRight: '5px' }}></i>
                                        <p style={{ margin: 0 }}><strong>Puntos: </strong>{usuario.puntos.length}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Info de usuario */}
                    <div className="row align-items-md-stretch mb-5 ">
                        <div className="col-md-12">

                            <div className="h-100 p-5 rounded-3 text-light" style={{backgroundColor: "black"}} >
                                <h2>Información de usuario</h2>
                                <p className="mb-5">Aquí puedes ver la información personal de tu cuenta.</p>
                                
                                {/* usuario */}
                                <div className="row mt-2">
                                    <div className="col-lg-6">
                                        <div className="d-flex  justify-content-center justify-content-lg-end text-light p-2 pt-2 bg-light bg-opacity-10 border border-light border-start-0 rounded-end">
                                            <h6 style={{marginBottom: "0px"}} >Usuario</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="d-flex justify-content-center justify-content-lg-start text-light p-2">
                                            <h6 style={{marginBottom: "0px"}} className="letraTelefono">{usuario.username}</h6>
                                        </div>
                                    </div>
                                </div>

                                {/* Correo */}
                                <div className="row mt-2">
                                    <div className="col-lg-6">
                                        <div className="d-flex  justify-content-center justify-content-lg-end text-light p-2 bg-light bg-opacity-10 border border-light border-start-0 rounded-end">
                                            <h6 style={{marginBottom: "0px"}}>Correo</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="d-flex justify-content-center justify-content-lg-start text-light p-2">
                                            <h6 style={{marginBottom: "0px"}} className="letraTelefono">{usuario.email}</h6>
                                        </div>
                                    </div>
                                </div>

                                {/* Nombre */}
                                <div className="row mt-2">
                                    <div className="col-lg-6">
                                        <div className="d-flex  justify-content-center justify-content-lg-end text-light p-2 bg-light bg-opacity-10 border border-light border-start-0 rounded-end">
                                            <h6 style={{marginBottom: "0px"}} >Nombre</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="d-flex justify-content-center justify-content-lg-start text-light p-2">
                                            <h6 style={{marginBottom: "0px"}} className="letraTelefono">{usuario.nombre}</h6>
                                        </div>
                                    </div>
                                </div>

                                {/* Apellidos */}
                                <div className="row mt-2">
                                    <div className="col-lg-6">
                                        <div className="d-flex  justify-content-center justify-content-lg-end text-light p-2 bg-light bg-opacity-10 border border-light border-start-0 rounded-end">
                                            <h6 style={{marginBottom: "0px"}} >Apellidos</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="d-flex justify-content-center justify-content-lg-start text-light p-2">
                                            <h6 style={{marginBottom: "0px"}} className="letraTelefono">{usuario.apellido}</h6>
                                        </div>
                                    </div>
                                </div>
                            
                                {/* Teléfono */}
                                <div className="row mt-2">
                                    <div className="col-lg-6">
                                        <div className="d-flex  justify-content-center justify-content-lg-end text-light p-2 bg-light bg-opacity-10 border border-light border-start-0 rounded-end">
                                            <h6 >Teléfono</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="d-flex justify-content-center justify-content-lg-start text-light p-2">
                                            <h6 style={{marginBottom: "0px"}}  className="letraTelefono">{usuario.telefono}</h6>
                                        </div>
                                    </div>
                                </div>

                                {/* Identificación */}
                                <div className="row my-2">
                                    <div className="col-lg-6">
                                        <div className="d-flex  justify-content-center justify-content-lg-end text-light p-2 bg-light bg-opacity-10 border border-light border-start-0 rounded-end">
                                            <h6 style={{marginBottom: "0px"}} >Identificación</h6>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="d-flex justify-content-center justify-content-lg-start text-light p-2">
                                            <h6 style={{marginBottom: "0px"}} className="letraTelefono">{usuario.identificacion}</h6>
                                        </div>
                                    </div>
                                </div> 

                                
                                <EliminarCuenta usuario={usuario.username} urlVolver={urlVolver} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    </div>
    )
}



export default Micuentausuario;